<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <ng-container *ngFor="let p of consulta?.lista; let i = index">
      <h2 class="subtitle">VERSÃO {{i+1}}: {{p?.codigo || 'NÃO INFORMADO'}}</h2>
      <ul class="card-list-striped">
        <li><span class="text-secondary">Marca</span><span>{{p?.marca || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Modelo</span><span>{{p?.modelo || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Código</span><span>{{p?.codigo || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Ano </span><span>{{p?.ano || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Cambio</span><span>{{p?.cambio || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Combustivel </span><span>{{p?.combustivel || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Configuração </span><span>{{p?.configuracao || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Potencia </span><span>{{p?.potencia || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Acessorio</span><span>{{p?.acessorio || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Versão</span><span>{{p?.versao || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Porta</span><span>{{p?.porta || 'NÃO INFORMADO'}}</span></li>
        <li><span class="text-secondary">Preço</span><span>{{p?.preco || 'NÃO INFORMADO'}}</span></li>
      </ul>
    </ng-container>

  </ng-container>

</app-card-consulta>
